var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{attrs:{"light":"","dense":"","fixed":"","app":"","clipped-left":_vm.clipped}},[_c('v-toolbar-title',[_c('img',{attrs:{"src":require("@/assets/logo.svg"),"height":"48px"}})]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }